module.exports = __webpack_public_path__ + "static/media/34.08a22b3e.svg";